const DynaCore_Log = {
    init: function () {
        'use strict';
        const button = $('#button-item-log');
        if (!button.length) {
            return;
        }

        button
            .off('click')
            .on('click', function() {
                const itemId = $('#idItem').val();
                const sectionId = $('#idSection').val();

                if (!itemId || !sectionId) {
                    return;
                }

                let url = window.location.href;
                url = url.replace('/item/edit', '/item/data-log');
                $.ajax({
                    type: 'post',
                    url: url,
                    data: {"sectionId": sectionId, "itemId": itemId},
                    dataType: "json",
                    success: function (r) {
                        if (r.hasOwnProperty('status') && true !== r['status']) {
                            Lemo_Alert.addInfo('Nebyly nalezeny žádné záznamy v logu.', 'logDownloadInfo');
                            return;
                        }

                        Lemo_Alert.addInfo('Vyčkejte na stažení souboru logu', 'logDownloadInfo', 2500);
                        const data = r['data'];
                        if (data.hasOwnProperty('uuid') && null !== data['uuid']) {
                            setTimeout(function() {
                                url = url.replace('/item/data-log/', '/item/data-log-download/');
                                url += '?uuid=' + data['uuid']
                                Lemo_Alert.closeById('logDownloadInfo');
                                window.location = url;
                            }, 3000);
                        } else {
                            Lemo_Alert.addDanger('Log změn se nepodařilo načíst.');
                        }
                    },
                    error: function (jqXHR) {
                        DynaCore_Item.alertXhrError(jqXHR);
                    }
                });
            });
    },
}

$(document)
    .ready(function () {
        DynaCore_Log.init();
    });
